import { Injectable } from '@angular/core';
import { LocalSettingsKey } from '@shared/types/local-settings';

@Injectable({
    providedIn: 'root'
})
export class ReadPaneService {
    lastAppliedTemplate: string;

    constructor() { }

    getActiveReadPaneTemplate(): string {
        return localStorage.getItem(LocalSettingsKey.READ_PANE_TEMPLATE) || 'double-view';
    }

    setReadPaneTemplate(template: string): void {
        localStorage.setItem(LocalSettingsKey.READ_PANE_TEMPLATE, template);
    }

    applyReadPaneTemplate(): void {
        const template = this.getActiveReadPaneTemplate();

        if (template === this.lastAppliedTemplate) {
            return;
        }

        this.setReadPaneTemplate(template);
    }
}
